<template>
  <div class="course-container">
    <headerPage></headerPage>
    <!-- 班级详情信息区域 -->
    <div class="course-wrapper">
      <el-row class="course-info-wrapper">
        <!-- 封面图片区域 -->
        <el-col :span="8" class="course-cover">
          <img :src="classLists.imageUrl" alt="班级封面" class="cover-image" />
        </el-col>

        <!-- 标题区域 -->
        <el-col :span="8" class="title-section">
          <h1 class="course-title">{{ classLists.title }}</h1>
        </el-col>

        <!-- 学员信息区域 -->
        <el-col :span="8" class="review-section">
          <svg t="1743926878329" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1230" width="200" height="200"><path d="M636.16 556.074667a233.642667 233.642667 0 1 0-247.978667 0 336.512 336.512 0 0 0-212.181333 312.192 29.994667 29.994667 0 1 0 59.904 0 276.224 276.224 0 1 1 552.405333 0 29.994667 29.994667 0 1 0 59.904 0 336.426667 336.426667 0 0 0-212.053333-312.192zM338.602667 358.4a173.738667 173.738667 0 1 1 347.434666-0.085333 173.738667 173.738667 0 0 1-347.434666 0.170666v-0.085333z" p-id="1231"></path></svg>
          <div class="course-rating">
            <span class="review-count">{{ classLists.reviews }} 学员</span>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="course-tou">
      <!-- 课程展示区域 -->
      <div class="page-header">
        <div class="page-header2">
        <!-- 返回按钮 -->
        <el-page-header @back="goBack"  class="return-button"></el-page-header>
        <h2 class="page-title">课程</h2>
        </div>
        <div class="divider"></div>
      </div>
      <div class="course-list">
        <el-row :gutter="20" class="course-row" v-if="classList.length > 0">
          <el-col :xs="24" :sm="12" :md="8" :lg="6" v-for="(course, index) in classList" :key="index"
                  class="course-col">
            <el-card class="course-card" shadow="hover">
              <!-- 课程图片 -->
              <img :src="course.courseImg" class="course-image" alt="课程图片" />

              <!-- 课程信息区域 -->
              <div class="course-info">
                <!-- 课程标题 -->
                <h3 class="course-title">{{ course.courseName }}</h3>

                <!-- 课程价格区域 -->
                <p class="course-price">价格：¥{{ course.coursePrice }}</p>

                <!-- 学习进度条区域 -->
                <div class="progress-container">
                  <span class="progress-label">学习进度：</span>
                  <el-progress :percentage="course.progress" :stroke-width="8"
                               :color="getProgressColor(course.progress)"
                               style="height: 8px; width: 70%;"></el-progress>
                </div>
              </div>

              <!-- 底部区域 -->
              <div class="bottom">
                <span class="course-time">{{ formatDate(course.createTime) }}</span>
                <el-button type="primary" size="mini" @click="viewDetail(course)">查看详情</el-button>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <el-empty v-else description="暂无数据" ></el-empty>
      </div>
    </div>

    <bottomPage></bottomPage>
  </div>
</template>

<script>
import headerPage from "@/components/header/header";
import bottomPage from "@/components/bottom/bottom";
import {getCoursesByClassIdWithWrapper} from "@/api/myClass";

export default {
  components: {
    headerPage,
    bottomPage,
  },
  data() {
    return {
      // 课程基本信息
      classLists: {
        classId:"",
        title: "", // 班级名称
        imageUrl: "", // 班级照片
        reviews: 245, // 示例学员数量
      },
      // 课程列表
      classList: [],
    };
  },
  created() {
    const {classId,className, classImg} = this.$route.params;
    this.classLists.classId = classId;
    this.classLists.title = className; // 直接使用传递过来的值
    this.classLists.imageUrl = classImg; // 直接使用传递过来的值
    this.getClassCouress()
  },
  methods: {
    async getClassCouress() {
      try {
        const response = await getCoursesByClassIdWithWrapper(this.classLists.classId);

        if (response && Array.isArray(response.data) && response.data.length > 0) {
          this.classList = response.data.map(course => ({
            id: course.id,
            courseImg: course.courseImg,
            courseName: course.courseName,
            coursePrice: course.coursePrice,
            courseType: course.courseType,
            progress: this.calculateProgress(course.completePercent),
          }));
        } else {
          console.warn("没有课程数据返回");
        }
      } catch (error) {
        console.error("获取课程基本信息失败：", error);
      }
    },
    // 计算进度百分比 (completeTime 为0时显示0%)
    calculateProgress(completeTime) {
      return completeTime > 0 ? Math.min(100, completeTime / 100) : 0;
    },
    // 格式化时间戳 -> yyyy-MM-dd
    formatDate(timestamp) {
      if (!timestamp) return "";
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    // 跳转到详情页面
    viewDetail(selectedCourse) {
      // 普通课程
      if (selectedCourse.courseType == 0) { 
        // 这里可以添加查看详情的逻辑
        this.$router.push({
          name: "classCourseDetail",
          params: {
            // 传递课程ID和班级ID
            courseId: selectedCourse.id,
            // 其他参数
            classId: this.classLists.classId,
            className: selectedCourse.courseName,
            classImg: selectedCourse.courseImg,
          },
        });
      } 
      // 习题课程
      else if (selectedCourse.courseType == 1) {
        this.$router.push({
          name: "questionCourseDetail",
          params: {
            courseId: selectedCourse.id,
            classId: this.classLists.classId
          },
        });
      }
    },
    getProgressColor(progress) {
      if (progress >= 80) return "#67C23A"; // 绿色
      else if (progress >= 50) return "#E6A23C"; // 黄色
      else return "#F56C6C"; // 红色
    },
    // 返回上一页
    goBack() {
        this.$router.push('/myClass');
    },
  },
};
</script>

<style scoped>
/* 页面容器样式 */
.course-container {
  background-color: #f5f5f5;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.course-wrapper{
  width: 100%;
  height: 260px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding:0 200px;
  box-sizing: border-box;
  overflow: hidden;
  background-color: #ffffff;
}
.course-tou{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding:0 200px;
  box-sizing: border-box;
  overflow: hidden;
  background-color: #ffffff;
}
/* 班级详情信息区域样式 */
.course-info-wrapper {
  display: flex;
  width: 100%;
  margin: 20px auto;
  background-color: #fff;
  border-radius: 10px;
  height: 100%; /* 限制总高度 */
  overflow: hidden; /* 隐藏超出部分 */
}

.course-cover {
  width: 33%;
  margin-right: 20px;
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
  overflow: hidden; /* 隐藏超出部分 */
}

.course-cover img {
  width: 100%;  /* 宽度自适应容器 */
  height: 100%;  /* 高度自适应容器 */
  object-fit: cover; /* 保持比例填充 */
}
.review-section {
  display: flex;
  flex-direction: column;
  align-items: center; /* 水平居中 */
  margin-top: 20px; /* 与标题的间距 */
}

/* 页头区域样式 */
.page-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.page-header2{
  display: flex;
  align-items: center;
}

/* 页标题样式 - 左对齐 */
.page-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  text-align: left;
}
/* 分割线样式 - 灰色铺满 */
.divider {
  width: 100%;
  height: 2px;
  background-color: #dcdfe6;
}
/* 课程列表样式 */
.course-list {
  width: 100%;
  height: 100%;
  overflow-y:auto;
  margin: 20px auto;
}
.course-row{
  width: 100%;
}
/* 课程卡片样式 */
.course-card {
  border-radius: 10px;
  overflow: hidden;
  transition: transform 0.3s;
}

/* 增加卡片的上下间距 */
.course-col {
  margin-bottom: 20px;
}

.course-card:hover {
  transform: translateY(-5px);
}

/* 课程图片样式 */
.course-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
}

/* 课程信息区域 */
.course-info {
  padding: 0 14px 14px 14px;
  background-color: #f9f9f9;
  border-top: 1px solid #ebeef5;
}

/* 课程标题 */
.course-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin: 5px 0 3px 0; /* 调整为2px，缩小间距 */
}

/* 课程价格样式 - 靠右对齐 */
.course-price {
  font-size: 16px;
  font-weight: bold;
  color: #ff5722;
  margin: 1px 0 10px 0;
  text-align: right;
}

/* 学习进度条容器 */
.progress-container {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.progress-label {
  font-size: 14px;
  color: #333;
  margin-right: 10px;
  white-space: nowrap;
}

.el-progress {
  display: flex;
  align-items: center;
  width: 100%; /* 确保进度条占满剩余空间 */
}

.el-progress__text {
  margin-left: 10px; /* 调整文本与进度条之间的间距 */
  font-size: 14px; /* 确保文本字体大小与标签一致 */
  color: #333; /* 确保文本颜色与标签一致 */
}

/* 底部区域样式 */
.bottom {
  padding: 10px 14px;
  border-top: 1px solid #ebeef5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fafafa;
}

/* 课程时间 */
.course-time {
  font-size: 12px;
  color: #999;
}

</style>
